import React, { useRef, useState } from "react";
import "./Our_recommendation.css";
import Common_title from "../../common-components/common-title/Common_title";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Autoplay, Pagination, Navigation } from "swiper/modules";
import Frames_card from "../../common-components/common-card/frame-card/Frames_card";

const Our_recommendation = ({ products ,product}) => {
  return (
    <>
      <section className="Our_recommendation_sec">
        <div className="container">
          <Common_title title={"Our "} titleblack={"recommendations"} />

          <div className="framesslider_sec">
            <Swiper
              slidesPerView={1}
              centeredSlides={false}
              navigation={true}
              autoplay={{
                delay: 2000000,
                disableOnInteraction: false,
              }}
              breakpoints={{
                0: {
                  slidesPerView: 2,
                  spaceBetween: 5,
                },
                575: {
                  slidesPerView: 2.5,
                  spaceBetween: 5,
                },
                768: {
                  slidesPerView: 3,
                  spaceBetween: 5,
                },
                991: {
                  slidesPerView: 3,
                  spaceBetween: 10,
                },
                1200: {
                  slidesPerView: 4,
                  spaceBetween: 10,
                },
              }}
              className="mySwiper"
              modules={[Autoplay, Navigation]}
            >
              {products?.data
                ?.filter((item) => Number(item.id) !== Number(product?.id)) // ❌ remove matched product
                .map((data, index) => (
                  <SwiperSlide key={index}>
                    <Frames_card
                      image={process.env.PUBLIC_URL + data.image}
                      type={data.type}
                      name={data.name}
                      id={data.id}
                      prise={data?.price || "N/A"}
                      oldprise={data?.mrp || "N/A"}
                    />
                  </SwiperSlide>
                ))}
              {/* {products?.data?.map((data, index) => (
                <SwiperSlide key={index}>
                  <Frames_card
                    image={process.env.PUBLIC_URL + data.image}
                    type={data.type}
                    name={data.name}
                    id={data.id}
                    prise={data?.price || "N/A"}
                    oldprise={data?.mrp || "N/A"}
                  />
                </SwiperSlide>
              ))} */}
            </Swiper>
          </div>
        </div>
      </section>
    </>
  );
};

export default Our_recommendation;
